/* eslint-disable max-len */
import { useIntl } from 'react-intl';
import env from 'src/env';
import LargeCard from 'src/Components/ComponentLibaryPlaceholder/Cards/LargeCard';

type Props = {
    isLoading: boolean
};
const DashboardCards = (props: Props) => {
    const { isLoading } = props;
    const intl = useIntl();
    const practitionerId = localStorage.getItem('active_practitioner_id');

    return (
        <section
            className='flex flex-wrap flex-col md:flex-row sm:justify-center
                md:justify-center xl:justify-start mr-2 items-center'>
            <LargeCard
                image={'svg/PlusCircle.svg'}
                className='bg-white mr-8 mt-6 xl:mt-8 xl:mr-8'
                heading={
                    intl.formatMessage({
                        id: 'LP_CREATE_NEW_PROJECT',
                        defaultMessage: 'Create New Project',
                    })
                }
                body= {
                    intl.formatMessage({
                        id: 'LP_CREATE_NEW_PROJECT_DESC',
                        defaultMessage: 'Create a new project using products like Lumina Spark, Lumina Select, Lumina Team and many more...',
                    })
                }
                onClick={() => {
                    window.location.href = `${env.ssoV1Url}/login-lumina-online/affiliate/${practitionerId}?returnUrl=${env.luminaOnlineUrl}/affiliateprojects/`;
                }}
                isLoading={isLoading}
            />

            <LargeCard
                image={'svg/Cog.svg'}
                className='bg-white mr-8 xl:mr-8 mt-6 xl:mt-8'
                heading={
                    intl.formatMessage({
                        id: 'LP_MANAGE_PROJECT',
                        defaultMessage: 'Manage Projects',
                    })
                }
                body={
                    intl.formatMessage({
                        id: 'LP_MANAGE_PROJECT_DESC',
                        defaultMessage: 'View your existing projects, edit settings, check Portraits, and manage and communicate with your participants...',
                    })
                }
                onClick={() => {
                    window.location.href = `${env.ssoV1Url}/login-lumina-online/affiliate/${practitionerId}?returnUrl=${env.luminaOnlineUrl}/affiliateprojects/`;
                }}
                isLoading={isLoading}
            />
            <LargeCard
                image={'svg/ShoppingCart.svg'}
                className='bg-white mr-8 sm:mr-8 xl:mr-0 mt-6 xl:mt-8'
                heading={
                    intl.formatMessage({
                        id: 'LP_LUMINA_STORE',
                        defaultMessage: 'Lumina Store',
                    })
                }
                body={
                    intl.formatMessage({
                        id: 'LP_LUMINA_STORE_DESC',
                        defaultMessage: 'Buy points, view your recent transactions, and purchase new products...',
                    })
                }
                onClick={() => {
                    window.location.href = `${env.luminaFinanceUrl}/login-lumina-finance/affiliate/${practitionerId}?targetUrl=https://finance.luminalearning.com/practitioner/store/`;
                }}
                isLoading={isLoading}
            />
        </section>
    );
};

export default DashboardCards;